<template>
  <div class="help-card">
    <nuxt-link
      :to="titleLink || link"
      :target="target"
      class="flex-y-center mb-[15px] gap-[5px]"
    >
      <NewTag v-if="data?.is_new"></NewTag>
      <div
        class="text-[20px] font-bold text-font-1"
        v-html="checkHightLight(data?.display_title?.text, words)"
      />
    </nuxt-link>
    <div class="flex gap-[20px]">
      <AudioItem
        v-if="data.audio_url"
        :data="data"
        class="h-[84px] w-[138px] flex-shrink-0"
      />
      <div
        v-else-if="data.image_url || data.video_url"
        class="h-[84px] w-[138px] flex-shrink-0"
        @click.stop="showMedia(data.video_url || data.image_url)"
      >
        <HoverVideo
          v-if="data.video_url"
          class="h-[60px]"
          :data="{
            cover_url: data.video_cover_url || data?.cover_url,
            hover_video: preview_video || data.video_url,
          }"
        >
        </HoverVideo>
        <Resource
          v-else-if="data.image_url"
          :src="data.image_url"
          class="w-full h-full rounded-[10px] cursor-pointer"
          :transformResource="transformImage"
        />
      </div>
      <nuxt-link :to="descLink || link" :target="target">
        <div class="flex flex-col justify-between h-full">
          <div
            class="text-font-1"
            v-html="checkHightLight(data?.display_content?.text, words)"
          />
          <slot name="other" />
        </div>
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
import HoverVideo from '../hoverVideo/index.vue'
import AudioItem from './audio.vue'
import { usePlayView } from '~/features/pageList/index'
import type { IHelpSearch } from '~/api/module/help-center'
defineProps<{
  data: IHelpSearch
  preview_video?: string
  words: string[] // 分词
  titleLink?: object // 标题跳转链接
  descLink?: object // 描述跳转链接
  link?: object // 整体跳转链接
  target?: string
}>()

const showMedia = (url?: string) => {
  usePlayView({ file_url: url })
}
</script>

<style lang="scss" scoped>
.help-card {
  @apply rounded-[8px];
}
</style>
